"use client"
import { useGSAP } from '@gsap/react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useRef } from 'react'
import { useApp } from '../context/AppContext'

gsap.registerPlugin(ScrollTrigger)

export default function Section({ children, isTopSection = false, theme = 'main-light', className = '', onEnter = () => { }, onEnterBack = () => { }, onLeave = () => { }, onLeaveBack = () => { }, ref, ...props }) {
  const internalRef = useRef(null);
  const sectionRef = ref || internalRef;
  const { headerHeight } = useApp()

  useGSAP(() => {
    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: () => {
        onEnter()
      },
      onEnterBack: () => {
        onEnterBack()
      },
      onLeave: () => {
        onLeave()
      },
      onLeaveBack: () => {
        onLeaveBack()
      }
    })
  })

  useGSAP(() => {
    const offset = isTopSection ? 1.5 * headerHeight : 0.5 * headerHeight

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: `top top+=${offset}`,
      end: `bottom top+=${offset}`,
      onEnter: () => {
        document.body.setAttribute('data-theme', theme)
      },
      onEnterBack: () => {
        document.body.setAttribute('data-theme', theme)
      },
    })

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: `top bottom`,
      end: `bottom bottom`,
      onEnter: () => {
        document.body.setAttribute('data-bottom-theme', theme)
      },
      onEnterBack: () => {
        document.body.setAttribute('data-bottom-theme', theme)
      },
    })
  }, { scope: sectionRef, dependencies: [theme, headerHeight], revertOnUpdate: true })

  return (
    <section
      ref={sectionRef}
      className={`section ${isTopSection && 'top-section'} ${className}`}
      data-section-theme={theme}
      {...props}
    >
      {children}
    </section>
  )
}
